import Content from "./Content";

export default class UnlockLocationContent extends Content {
    constructor(languagePack, contentID, locationID, x, y, label) {
        super(UnlockLocationContent.NAME, UnlockLocationContent.TYPE, label, languagePack, contentID);

        this._locationID;
        this._x;
        this._y;

        this.setX(x);
        this.setY(y);

        this.setLocationID(locationID);
    }

    setLocationID(value) {
        this._locationID = value;
    }

    getLocationID() {
        return this._locationID;
    }

    setX(value) {
        this._x = value;
    }

    getX() {
        return this._x;
    }

    setY(value) {
        this._y = value;
    }

    getY() {
        return this._y;
    }

    convertToObject() {
        return this.getObject(["x", "y"]);
    }
}

UnlockLocationContent.NAME = "UnlockLocation";
UnlockLocationContent.TYPE = "engUnlockLocation";
UnlockLocationContent.LOCATION_ID_LABEL = "locationID";